import { render, staticRenderFns } from "./ReturnProductAdjustmentStockTable.vue?vue&type=template&id=773467f0"
import script from "./ReturnProductAdjustmentStockTable.vue?vue&type=script&lang=js"
export * from "./ReturnProductAdjustmentStockTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports